import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';
import { authApi } from '../api/client';
import { isTelegram, tg, tgInit } from '../utils/telegram';

const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth должен использоваться внутри AuthProvider');
  return ctx;
};

AuthProvider.propTypes = { children: PropTypes.node };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const bootstrap = useCallback(async () => {
    tgInit();

    const token = localStorage.getItem('ck_token');
    if (token) {
      try {
        setUser(await authApi.me());
        setLoading(false);
        return;
      } catch {
        localStorage.removeItem('ck_token');
      }
    }

    // Автовход через Telegram
    if (isTelegram()) {
      try {
        const res = await authApi.telegram(tg().initData);
        localStorage.setItem('ck_token', res.accessToken);
        setUser(res.user);
      } catch {
        /* покажем экран входа */
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const devLogin = async (userId) => {
    const res = await authApi.devLogin(userId);
    localStorage.setItem('ck_token', res.accessToken);
    setUser(res.user);
    return res.user;
  };

  const refresh = async () => {
    try {
      setUser(await authApi.me());
    } catch {
      /* no-op */
    }
  };

  const updateProfile = async (data) => {
    const updated = await authApi.updateMe(data);
    setUser(updated);
    return updated;
  };

  const logout = () => {
    localStorage.removeItem('ck_token');
    localStorage.removeItem('ck_cart');
    setUser(null);
    window.location.href = '/login';
  };

  const value = useMemo(
    () => ({ user, loading, devLogin, logout, refresh, updateProfile, isAuthenticated: !!user }),
    [user, loading]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
